import produce from "immer";
import { ENABLE_AS_OF_DATE, DELETE_AS_OF_DATE } from "state/misc/actions";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import SelectionState from "state/selections/SelectionState";

const defaultState = {
  enableAsOfDate: false,
};

const reducer = produce(
  (
    state = {
      [SelectionState.UNCOMMITTED]: defaultState,
      [SelectionState.COMMITTED]: defaultState,
    },
    action
  ) => {
    switch (action.type) {
      case ENABLE_AS_OF_DATE:
        state[SelectionState.UNCOMMITTED].enableAsOfDate =
          action.payload.enable;
        break;
      case DELETE_AS_OF_DATE:
        state[SelectionState.UNCOMMITTED].enableAsOfDate = false;
        state[SelectionState.COMMITTED].enableAsOfDate = false;
        break;
      case COMMIT_SELECTIONS: {
        state[SelectionState.COMMITTED] = state[SelectionState.UNCOMMITTED];
        break;
      }
      default:
        return state;
    }
  }
);

export default reducer;
